import { ApolloClient } from "apollo-client";
import { createHttpLink } from "apollo-link-http";
import { setContext } from "apollo-link-context";
import { InMemoryCache } from "apollo-cache-inmemory";

import { Auth } from "aws-amplify";

import config from "../config";

const httpLink = createHttpLink({
  uri: config.READ_SERVER_URL,
});

const extractToken = (idToken) =>
  idToken && idToken.jwtToken ? `Bearer ${idToken.jwtToken}` : "";

export const refreshSession = async () => {
  try {
    const cognitoUser = await Auth.currentAuthenticatedUser();
    const currentSession = await Auth.currentSession();
    const session = await new Promise((resolve) =>
      cognitoUser.refreshSession(
        currentSession.refreshToken,
        (err, session) => {
          resolve(session);
        }
      )
    );
    console.log("session", session);
    const { idToken = {} } = await Auth.currentSession();
    console.log("idToken", idToken);
    if (window) {
      window.location = "";
    }
  } catch (e) {
    console.log("Unable to refresh Token", e);
  }
};

const authLink = setContext(async (_, { headers }) => {
  const { idToken = {} } = await Auth.currentSession();

  return {
    headers: {
      ...headers,
      authorization: extractToken(idToken),
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
